import classNames from "classnames/bind";
import { ResolvedInvestorAnnouncements } from "resolvers/data/investorAnnouncementsResolver";

import Button from "../Button";
import Announcement from "./Announcement";
import styles from "./InvestorAnnouncements.module.scss";

const cx = classNames.bind(styles);

export default function InvestorAnnouncements({
    heading,
    cta,
    investorAnnouncements,
}: ResolvedInvestorAnnouncements) {
    return (
        <div className={cx("investorAnnouncement")}>
            <h2>{heading}</h2>
            <Announcement investorAnnouncements={investorAnnouncements} />
            <Button
                className={cx("ctaButton")}
                href={cta.link}
                theme={cta.priority}
                target={cta.target}
                autoWidth
            >
                {cta.text}
            </Button>
        </div>
    );
}
